import { usePageStateValueWithDefault } from '../../../stores/PageStateStore';
import CertificateDetailPage from './CertificateDetailPage';

import { CERTIFICATE_DATA_SOURCE, TRUSTED_DATA_SOURCE } from './CertificateConstants';

export default function CertificateDetailRouter(props) {
    const [activeTab] = usePageStateValueWithDefault('activeTab', 'certificates');

    if (activeTab === 'trusted') {
        return <CertificateDetailPage {...props} activeTab={activeTab} dataSource={TRUSTED_DATA_SOURCE} />;
    }

    return <CertificateDetailPage {...props} activeTab={activeTab} dataSource={CERTIFICATE_DATA_SOURCE} />;
}
